module.exports = __webpack_public_path__ + "media/images/cloud-b17ec35f.png";